// @ts-nocheck
import { useAuth } from 'src/context/auth.context'
import Initial from 'src/components/image/Initial'
import { Col, Row } from 'antd'

import styles from '../index.module.scss'

const SidebarHeader = () => {
  const { getUserData, activeBranchId, activeEntityId, branches, entities } = useAuth()
  const sessionUser = getUserData()?.user
  const activeBranch = branches?.find((branch) => branch.id === activeBranchId)
  const activeEntity = entities?.find((entity) => entity.id === activeEntityId)

  return (
    <div className={styles?.sidebarHeaderContainer}>
      <Row>
        <Col xs={4} sm={4}>
          <div className={styles?.imgWrapper}>
            <Initial
              name={
                sessionUser?.user?.name ||
                sessionUser?.ibo?.name ||
                '-'
              }
            />
          </div>
        </Col>
        <Col xs={20} sm={20}>
          <div className={styles?.username}>
            {sessionUser?.user?.name ||
              sessionUser?.ibo?.name ||
              '-'}
          </div>
          <div className={styles?.email}>
            {sessionUser?.user?.email ||
              sessionUser?.ibo?.email ||
              '-'}
          </div>
          <div className={styles?.email}>
            {activeBranch
              ? `${activeBranch?.entity_name} / ${activeBranch?.name}`
              : activeEntity
                ? `${activeEntity.name} / All branches`
                : 'All branches in entity'}
          </div>
        </Col>
      </Row>
    </div>
  )
}

export default SidebarHeader
